import { getIn, useFormikContext } from "formik";
import { useToastContext } from "../../../../../../../../common/components/ui/toast/toast.context";
import RegisterPhotos from "./RegisterPhotos";
import {
  unlinkVehicleRenter,
  updateRenterProps,
} from "../../../../../../../../common/services/renters.api";
import { updateVehicleVisualRecords } from "../../../../../../../../common/services/vehicles.api";
import ButtonWithLoader from "../../../../../../../../common/components/ui/loading/ButtonLoading";
import { useCallback, useEffect, useState } from "react";
import { VEHICLE_STATUS } from "../../../../../../../../types/vehicle.type";
import { CheckboxField } from "./CheckboxField";
import { partsEvaluationData } from "@/common/helpers/partsEvaluationData";
import { RENTER_STATUS } from "@/types/renter.type";
import { useRenterDashboardContext } from "@/modules/renters/components/renter-dashboard/useRenterDashboardContext";
// import TextAreaFormik from "../../../../../../../../common/components/form/TextAreaFormik";

type PartsEvaluation = {
  [key: string]: {
    Avariado: boolean;
    "Não Avariado": boolean;
  };
};

type RegisterGridProps = {
  title?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registers: Array<any>;
  onAddRegister?: () => void;
  onRemoveRegister: (index: number) => void;
  onStepChange?: (step: number) => void;
  onCloseModal?: () => void;
  isLicensePlateEmpty?: boolean;
  action?: string;
  plan?: string;
};
interface FormValues {
  partsEvaluation: { [key: string]: boolean }; // Defina o tipo correto para sua necessidade
  returnReason: string;
  observation?: string;
}

export default function InspectionRegister(props: RegisterGridProps) {
  const { title, registers, onRemoveRegister } = props;
  const { renter } = useRenterDashboardContext();
  const [isLoading, setIsLoading] = useState(false);
  const formik = useFormikContext<FormValues>();
  const [disableButton, setDisableButton] = useState(true);
  const vehicle = getIn(formik.values, "vehicle");
  const renterId = getIn(formik.values, "renterId");
  const nameRenter = getIn(formik.values, "renterName");
  const licensePlate = getIn(formik.values, "licensePlate");
  const { notifySuccess, notifyError } = useToastContext();
  const returnReason = getIn(formik.values, "returnReason");
  const optionRepossesion =
    getIn(formik.values, "optionRepossesion") || "UNDEFINED";

  const verifyAllPiecesAndObservations = useCallback(() => {
    if (!formik.values || !formik.values.partsEvaluation) {
      return true;
    }

    const keysPieces = [
      "abaLateralTanqueDireita",
      "abaLateralTanqueEsquerda",
      "blocoOptico",
      "borrachaEstriboDireita",
      "borrachaEstriboEsquerda",
      "carenagemRabetaCentral",
      "carenagemRabetaLateralDireita",
      "carenagemRabetaLateralEsquerda",
      "chaveIgnição",
      "desempenoChassi",
      "estribo",
      "espelhoRetrovisorDireito",
      "espelhoRetrovisorEsquerdo",
      "kitPff",
      "maneteDeFreio",
      "maneteDaEmbreagem",
      "paralamaDianteiro",
      "pinturaTanqueComLanternagem",
      "pinturaTanqueSemLanternagem",
      "ponteira",
      "protetorCarenagem",
      "roda",
      "suporteCelular",
      "tampaLateralDireita",
      "tampaLateralEsquerda",
      "trocaPlaca",
    ];
    return Object.keys(formik.values.partsEvaluation).filter((key) =>
      keysPieces.includes(key)
    ).length < keysPieces.length
      ? true
      : false;
  }, [formik.values]);

  const onAddRegister = () => {
    formik.setFieldValue("registers", [
      ...registers,
      { type: "", content: "", verified: false },
    ]);
  };

  useEffect(() => {
    if (optionRepossesion !== "UNDEFINED") {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [optionRepossesion]);

  const getPartsEvaluation = (): PartsEvaluation => {
    const parts: PartsEvaluation = {};

    // Seleciona todos os containers
    const containers = document.querySelectorAll<HTMLDivElement>(
      ".containerPartsEvaluation"
    );

    containers.forEach((container) => {
      const partName =
        container
          .querySelector<HTMLParagraphElement>("p")
          ?.textContent?.trim() ?? "Desconhecido";

      const avariadoOption = container.querySelector<HTMLDivElement>(
        ".containerPartsEvaluation-checkboxs .text-redPrimary"
      );
      const naoAvariadoOption = container.querySelector<HTMLDivElement>(
        ".containerPartsEvaluation-checkboxs .text-greenPrimary"
      );

      if (avariadoOption && naoAvariadoOption) {
        const isAvariado =
          avariadoOption.querySelector<SVGPathElement>(
            "svg path[d*='6.207 6.207']"
          ) !== null;
        const isNaoAvariado =
          naoAvariadoOption.querySelector<SVGPathElement>(
            "svg path[d*='6.207 6.207']"
          ) !== null;

        parts[partName] = {
          Avariado: isAvariado,
          "Não Avariado": isNaoAvariado,
        };
      }
    });

    return parts;
  };

  const getAvariadoPartsText = (partsEvaluation: PartsEvaluation): string => {
    // Pega todas as peças que estão "Avariado"
    const avariadoParts = Object.entries(partsEvaluation)
      .filter(([, status]) => status.Avariado)
      .map(([partName]) => partName);

    // Verifica se existem peças avariadas
    if (avariadoParts.length === 0) {
      return "Nenhuma peça está avariada.";
    }

    // Gera um texto formatado com os itens
    return `Peças Avariadas:\n- ${avariadoParts.join("\n- ")}`;
  };

  const hanlderVehicleRenter = async () => {
    setDisableButton(true);
    setIsLoading(true);
    try {
      const plan = renter?.activationData?.plan?.label;
      let availableForRent = true;
      if (plan.includes("SV") && optionRepossesion === "VEHICLE_EXCHANGE") {
        availableForRent = false;
      }
      const unlinkData = {
        renterId: renterId,
        vehicleId: vehicle._id,
        newStatusVehicle: VEHICLE_STATUS.TRIAGE,
        optionRepossesion: optionRepossesion,
        partsEvaluation: formik.values.partsEvaluation,
        observation: formik.values.observation,
        availableForRent: availableForRent,
      };

      const resultUnlinkVehicle = await unlinkVehicleRenter(unlinkData);

      if (!resultUnlinkVehicle.ok) {
        notifyError(resultUnlinkVehicle.message as string);
        setDisableButton(false);
        return;
      }

      notifySuccess("Veículo desvinculado com sucesso");

      const resultGetPartsEvaluation = getPartsEvaluation();
      const newReturnReason = `${returnReason}\n\n${getAvariadoPartsText(
        resultGetPartsEvaluation
      )}`;

      // 2. Em seguida, salvar as fotos/registros visuais
      const savePhotoDelivery = {
        renterId: renterId,
        vehicleId: vehicle._id,
        photos: registers,
        nameRenter: nameRenter,
        licensePlate: licensePlate,
        returnReason: newReturnReason,
      };

      const resultPhoto = await updateVehicleVisualRecords(savePhotoDelivery);

      if (!resultPhoto.ok) {
        notifyError(resultPhoto.message as string);
        // Reativa o botão em caso de erro
        setDisableButton(false);
        return;
      }

      notifySuccess("Fotos salvas com sucesso");

      if (plan && plan.startsWith("SV")) {
        const renterUpdateData = {
          status: RENTER_STATUS.WaitingRescision,
        };

        const resultUpdateStatus = await updateRenterProps(
          renterId,
          renterUpdateData
        );

        if (!resultUpdateStatus.ok) {
          notifyError(
            `Não foi possível alterar o status do cliente: ${resultUpdateStatus.message}`
          );
        } else {
          notifySuccess("Status do cliente atualizado para Rescisão");
        }
      }

      formik.setFieldValue("registers", [
        { type: "Frente do veículo", content: "" },
        { type: "Lateral direita do veículo", content: "" },
        { type: "Lateral esquerda do veículo", content: "" },
        { type: "Traseira do veículo", content: "" },
        { type: "Odômetro", content: "" },
      ]);
      if (props.onCloseModal) {
        props.onCloseModal();
      }
    } catch (error) {
      console.error("Erro ao processar operações:", error);
      notifyError("Ocorreu um erro ao processar a operação");
      setDisableButton(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="p-4">
      <RegisterPhotos
        title={title || "Inspeção de Veículo"}
        items={registers}
        vehicleId={vehicle._id}
        key={vehicle?._id || "no-vehicle"}
        renterId={renterId}
        nameRenter={nameRenter}
        onAddItem={onAddRegister}
        onRemoveItem={onRemoveRegister}
        updateStatus={undefined}
        titleTextArea={"Descreva o motivo da devolução:"}
      />

      <div className="mt-8">
        {partsEvaluationData.map((part) => (
          <CheckboxField
            key={part.name}
            name={`partsEvaluation.${part.name}`}
            label={part.label}
            onChange={() => { }}
          />
        ))}

        <div className="flex justify-end mt-2">
          <ButtonWithLoader
            disabled={disableButton || verifyAllPiecesAndObservations()}
            type="button"
            onClick={hanlderVehicleRenter}
            isLoading={isLoading}
          >
            Desvincular
          </ButtonWithLoader>
        </div>
      </div>
    </section>
  );
}
